import { getMethodWithParamWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const SEARCH_APPOINTMENT_LIST = 'SEARCH_APPOINTMENT_LIST';
export const SEARCH_APPOINTMENT_LIST_SUCCESS =
  'SEARCH_APPOINTMENT_LIST_SUCCESS';
export const SEARCH_APPOINTMENT_LIST_FAILURE =
  'SEARCH_APPOINTMENT_LIST_FAILURE';

// Action Creators
export const fetchGetSearchAppointment = () => ({
  type: SEARCH_APPOINTMENT_LIST,
});

export const fetchGetSearchAppointmentSuccess = (data) => ({
  type: SEARCH_APPOINTMENT_LIST_SUCCESS,
  payload: data,
});

export const fetchGetSearchAppointmentFailure = (error) => ({
  type: SEARCH_APPOINTMENT_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getSearchAppointmentCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetSearchAppointment(data, external));
    try {
      const response = await getMethodWithParamWithToken(
        url.getSearchAppointmentList,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetSearchAppointmentSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetSearchAppointmentFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetSearchAppointmentFailure(error.message));
    }
  };
};
